/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumPatientContactType = "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type QueryChatQueryVariables = {
    id: string;
    includeActions: boolean;
    includePatientJourney: boolean;
    includeToolbarNavigationPatient: boolean;
};
export type QueryChatQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"ActionsPatient_Viewer" | "Chat_Viewer">;
    } | null;
    readonly patientById: {
        readonly _id: string;
        readonly doNotContact: boolean | null;
        readonly contact: ReadonlyArray<{
            readonly active: boolean | null;
            readonly type: EnumPatientContactType | null;
            readonly value: string | null;
            readonly archived: boolean | null;
        } | null> | null;
        readonly " $fragmentRefs": FragmentRefs<"CardPatient_Patient" | "ActionsPatient_Patient" | "ToolbarNavigationPatient_Patient" | "Chat_Patient" | "HubPatientJourney_Patient">;
    } | null;
};
export type QueryChatQuery = {
    readonly response: QueryChatQueryResponse;
    readonly variables: QueryChatQueryVariables;
};



/*
query QueryChatQuery(
  $id: MongoID!
  $includeActions: Boolean!
  $includePatientJourney: Boolean!
  $includeToolbarNavigationPatient: Boolean!
) {
  viewer {
    ...ActionsPatient_Viewer @include(if: $includeActions)
    ...Chat_Viewer
    id
  }
  patientById(_id: $id) {
    _id
    doNotContact
    contact {
      active
      type
      value
      archived
    }
    ...CardPatient_Patient @include(if: $includeActions)
    ...ActionsPatient_Patient @include(if: $includeActions)
    ...ToolbarNavigationPatient_Patient @include(if: $includeToolbarNavigationPatient)
    ...Chat_Patient
    ...HubPatientJourney_Patient @include(if: $includePatientJourney)
    id
  }
}

fragment ActionsChatActivity_ChatActivity on ChatActivity {
  _id
  status
  ...ButtonChatActivityOpen_ChatActivity
  ...ButtonChatActivityReassign_ChatActivity
}

fragment ActionsPatient_Patient on Patient {
  _id
  contact {
    type
    active
  }
  chatActivity {
    _id
    status
    assignee {
      _id
      id
    }
    groupAssignee {
      _id
      id
    }
    ...AvatarChatActivityReassign_ChatActivity
    id
  }
  ...IconButtonPatientActions_Patient_2hOuXI
}

fragment ActionsPatient_Viewer on User {
  type
  user {
    setting {
      settings {
        telehealth {
          enabled
        }
      }
      id
    }
    id
  }
  setting {
    settings {
      telehealth {
        enabled
      }
    }
    id
  }
  ...IconButtonPatientActions_Viewer
}

fragment AvatarChatActivityReassign_ChatActivity on ChatActivity {
  _id
  assignee {
    ...AvatarNode_Node
    id
  }
  groupAssignee {
    ...AvatarNode_Node
    id
  }
}

fragment AvatarNode_Node on Node {
  __isNode: __typename
  __typename
  ... on Group {
    groupName: name
  }
  ... on Patient {
    name
    oid_avatar
    isOnline
  }
  ... on Provider {
    name
    oid_avatar
    isOnline
  }
  ... on User {
    name
    oid_avatar
    isOnline
  }
  ... on ChatActivity {
    patient {
      name
      oid_avatar
      isOnline
      id
    }
  }
}

fragment ButtonChatActivityOpen_ChatActivity on ChatActivity {
  _id
}

fragment ButtonChatActivityReassign_ChatActivity on ChatActivity {
  _id
}

fragment ButtonChatMessageSubmit_Patient on Patient {
  doNotContact
  contact {
    active
    type
  }
  ...PopperPatientContactSelect_Patient
}

fragment CardPatient_Patient on Patient {
  ...AvatarNode_Node
  _id
  name
  firstname
  lastname
  medicalRecordNumber
  createdAt
  lastLogin
  dateOfBirth {
    day
    month
    year
  }
}

fragment ChatInput_Patient on Patient {
  _id
  createdAt
  updatedAt
  balance
  name
  firstname
  lastname
  doNotContact
  contact {
    active
    type
    value
    archived
  }
  subscribers {
    subscribed
    user
  }
  ...ButtonChatMessageSubmit_Patient
}

fragment ChatMessageTyping_Node on Node {
  __isNode: __typename
  ... on Patient {
    _id
  }
  ... on Provider {
    _id
  }
  ... on User {
    _id
  }
  ...AvatarNode_Node
}

fragment ChatMessage_Message on Message {
  automated
  createdAt
  oid_file
  ref
  text
  type
  visibility
  mentions {
    mention
  }
  createdBy(includeDeleted: true) {
    name
    ...AvatarNode_Node
    id
  }
  patient(includeDeleted: true) {
    name
    ...AvatarNode_Node
    id
  }
  ...TypographyMessageDetails_Message
}

fragment ChatMessage_Viewer on User {
  user {
    salesforceData {
      respectProvisioning
    }
    setting {
      settings {
        communication {
          suppressMessagesByProvisioning
        }
      }
      id
    }
    id
  }
}

fragment Chat_Patient on Patient {
  ...InfiniteScrollMessages_Patient
  ...ChatInput_Patient
  chatActivity {
    status
    deleted
    ...ActionsChatActivity_ChatActivity
    id
  }
}

fragment Chat_Viewer on User {
  ...InfiniteScrollMessages_Viewer
}

fragment HubPatientJourney_Patient on Patient {
  _id
  name
  firstname
  lastname
  master
  dateOfBirth {
    day
    month
    year
  }
}

fragment IconButtonPatientActions_Patient_2hOuXI on Patient {
  _id
  chatActivity {
    _id
    status
    assignee {
      _id
      id
    }
    groupAssignee {
      _id
      id
    }
    id
  }
}

fragment IconButtonPatientActions_Viewer on User {
  _id
  roles
}

fragment IconPatientContactType_PatientContact on PatientContact {
  type
}

fragment InfiniteScrollMessages_Patient on Patient {
  id
  _id
  ...ChatMessageTyping_Node
  name
  firstname
  lastname
  master
  avatar: oid_avatar
  messagesConnection(first: 25, filter: {_operators: {visibility: {in: [public, internal]}, status: {ne: skipped}}}) {
    edges {
      node {
        _id
        oid_patient
        text
        type
        channel
        key
        externalId {
          value
        }
        externalStatus {
          reason
        }
        retry {
          originalMessage
          count
        }
        oid_facility
        oid_createdBy
        oid_recipient
        ...ChatMessage_Message
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment InfiniteScrollMessages_Viewer on User {
  ...ChatMessage_Viewer
}

fragment ListItemPatientContact_PatientContact on PatientContact {
  __typename
  active
  type
  value
  ...IconPatientContactType_PatientContact
}

fragment ListPatientContacts_Patient on Patient {
  doNotContact
  contact {
    active
    type
    value
    ...ListItemPatientContact_PatientContact
  }
}

fragment PopperPatientContactSelect_Patient on Patient {
  ...ListPatientContacts_Patient
}

fragment ToolbarNavigationPatient_Patient on Patient {
  _id
  ...AvatarNode_Node
  ...TypographyNodeName_Node
  ...TypographyNodeDob_Node
}

fragment TypographyMessageDetails_Message on Message {
  channel
  createdAt
  ref
  secure
  type
  visibility
  to
  facility {
    _id
    name
    id
  }
  media {
    url
  }
  retry {
    count
  }
  notifyTo {
    channel
    to
  }
  status
  externalStatus {
    reason
  }
}

fragment TypographyNodeDob_Node on Node {
  __isNode: __typename
  ... on Patient {
    dateOfBirth {
      day
      month
      year
    }
  }
  ... on Provider {
    dateOfBirth {
      day
      month
      year
    }
  }
  ... on User {
    dateOfBirth {
      day
      month
      year
    }
  }
}

fragment TypographyNodeName_Node on Node {
  __isNode: __typename
  ... on Group {
    groupName: name
  }
  ... on Patient {
    name
  }
  ... on Provider {
    name
  }
  ... on User {
    name
  }
  ... on Facility {
    facilityName: name
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeActions"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includePatientJourney"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeToolbarNavigationPatient"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "_id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "doNotContact",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "SettingSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SettingSettingsTelehealth",
      "kind": "LinkedField",
      "name": "telehealth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "_operators": {
        "status": {
          "ne": "skipped"
        },
        "visibility": {
          "in": [
            "public",
            "internal"
          ]
        }
      }
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channel",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v15 = [
  {
    "kind": "Literal",
    "name": "includeDeleted",
    "value": true
  }
],
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "groupName",
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Group",
  "abstractKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_avatar",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOnline",
  "storageKey": null
},
v19 = [
  (v17/*: any*/),
  (v18/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Patient",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Provider",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "User",
  "abstractKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Patient",
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ChatActivity",
  "abstractKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v16/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v25 = [
  (v11/*: any*/),
  (v8/*: any*/),
  (v24/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "to",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v28 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "day",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "month",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "year",
    "storageKey": null
  }
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "PatientDateOfBirth",
  "kind": "LinkedField",
  "name": "dateOfBirth",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v30 = [
  (v11/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/)
],
v31 = [
  (v2/*: any*/),
  (v8/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v16/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": (v30/*: any*/),
        "type": "Patient",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v30/*: any*/),
        "type": "Provider",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v30/*: any*/),
        "type": "User",
        "abstractKey": null
      },
      (v23/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QueryChatQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "includeActions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ActionsPatient_Viewer"
              }
            ]
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Chat_Viewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "patientById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientContact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "condition": "includeActions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CardPatient_Patient"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ActionsPatient_Patient"
              }
            ]
          },
          {
            "condition": "includeToolbarNavigationPatient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ToolbarNavigationPatient_Patient"
              }
            ]
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Chat_Patient"
          },
          {
            "condition": "includePatientJourney",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HubPatientJourney_Patient"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QueryChatQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserSalesforceData",
                "kind": "LinkedField",
                "name": "salesforceData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "respectProvisioning",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Setting",
                "kind": "LinkedField",
                "name": "setting",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SettingSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SettingSettingsCommunication",
                        "kind": "LinkedField",
                        "name": "communication",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "suppressMessagesByProvisioning",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "condition": "includeActions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Setting",
                    "kind": "LinkedField",
                    "name": "setting",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Setting",
                "kind": "LinkedField",
                "name": "setting",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "roles",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "patientById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientContact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "master",
            "storageKey": null
          },
          {
            "alias": "avatar",
            "args": null,
            "kind": "ScalarField",
            "name": "oid_avatar",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": "MessageConnection",
            "kind": "LinkedField",
            "name": "messagesConnection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Message",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "oid_patient",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "key",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MessageExternalId",
                        "kind": "LinkedField",
                        "name": "externalId",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MessageExternalStatus",
                        "kind": "LinkedField",
                        "name": "externalStatus",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "reason",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MessageRetry",
                        "kind": "LinkedField",
                        "name": "retry",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "originalMessage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "count",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "oid_facility",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "oid_createdBy",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "oid_recipient",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "automated",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "oid_file",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ref",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "visibility",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MessageMentions",
                        "kind": "LinkedField",
                        "name": "mentions",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mention",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v15/*: any*/),
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v25/*: any*/),
                        "storageKey": "createdBy(includeDeleted:true)"
                      },
                      {
                        "alias": null,
                        "args": (v15/*: any*/),
                        "concreteType": "Patient",
                        "kind": "LinkedField",
                        "name": "patient",
                        "plural": false,
                        "selections": (v25/*: any*/),
                        "storageKey": "patient(includeDeleted:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "secure",
                        "storageKey": null
                      },
                      (v26/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v11/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MessageMedia",
                        "kind": "LinkedField",
                        "name": "media",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MessageNotifyTo",
                        "kind": "LinkedField",
                        "name": "notifyTo",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      (v8/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "messagesConnection(filter:{\"_operators\":{\"status\":{\"ne\":\"skipped\"},\"visibility\":{\"in\":[\"public\",\"internal\"]}}},first:25)"
          },
          {
            "alias": null,
            "args": (v12/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "InfiniteScrollMessages_messagesConnection",
            "kind": "LinkedHandle",
            "name": "messagesConnection"
          },
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "balance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientSubscribers",
            "kind": "LinkedField",
            "name": "subscribers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subscribed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "user",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatActivity",
            "kind": "LinkedField",
            "name": "chatActivity",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deleted",
                "storageKey": null
              },
              (v2/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "condition": "includeActions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medicalRecordNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastLogin",
                "storageKey": null
              },
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatActivity",
                "kind": "LinkedField",
                "name": "chatActivity",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": (v31/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Group",
                    "kind": "LinkedField",
                    "name": "groupAssignee",
                    "plural": false,
                    "selections": (v31/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v24/*: any*/)
            ]
          },
          {
            "condition": "includeToolbarNavigationPatient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/),
                  (v16/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v29/*: any*/)
                    ],
                    "type": "Patient",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProviderDateOfBirth",
                        "kind": "LinkedField",
                        "name": "dateOfBirth",
                        "plural": false,
                        "selections": (v28/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Provider",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserDateOfBirth",
                        "kind": "LinkedField",
                        "name": "dateOfBirth",
                        "plural": false,
                        "selections": (v28/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  (v23/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "facilityName",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "type": "Facility",
                    "abstractKey": null
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v16/*: any*/),
              (v23/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          },
          {
            "condition": "includePatientJourney",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v29/*: any*/)
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f094fa742f965d5bbade0b5f65c511bf",
    "id": null,
    "metadata": {},
    "name": "QueryChatQuery",
    "operationKind": "query",
    "text": "query QueryChatQuery(\n  $id: MongoID!\n  $includeActions: Boolean!\n  $includePatientJourney: Boolean!\n  $includeToolbarNavigationPatient: Boolean!\n) {\n  viewer {\n    ...ActionsPatient_Viewer @include(if: $includeActions)\n    ...Chat_Viewer\n    id\n  }\n  patientById(_id: $id) {\n    _id\n    doNotContact\n    contact {\n      active\n      type\n      value\n      archived\n    }\n    ...CardPatient_Patient @include(if: $includeActions)\n    ...ActionsPatient_Patient @include(if: $includeActions)\n    ...ToolbarNavigationPatient_Patient @include(if: $includeToolbarNavigationPatient)\n    ...Chat_Patient\n    ...HubPatientJourney_Patient @include(if: $includePatientJourney)\n    id\n  }\n}\n\nfragment ActionsChatActivity_ChatActivity on ChatActivity {\n  _id\n  status\n  ...ButtonChatActivityOpen_ChatActivity\n  ...ButtonChatActivityReassign_ChatActivity\n}\n\nfragment ActionsPatient_Patient on Patient {\n  _id\n  contact {\n    type\n    active\n  }\n  chatActivity {\n    _id\n    status\n    assignee {\n      _id\n      id\n    }\n    groupAssignee {\n      _id\n      id\n    }\n    ...AvatarChatActivityReassign_ChatActivity\n    id\n  }\n  ...IconButtonPatientActions_Patient_2hOuXI\n}\n\nfragment ActionsPatient_Viewer on User {\n  type\n  user {\n    setting {\n      settings {\n        telehealth {\n          enabled\n        }\n      }\n      id\n    }\n    id\n  }\n  setting {\n    settings {\n      telehealth {\n        enabled\n      }\n    }\n    id\n  }\n  ...IconButtonPatientActions_Viewer\n}\n\nfragment AvatarChatActivityReassign_ChatActivity on ChatActivity {\n  _id\n  assignee {\n    ...AvatarNode_Node\n    id\n  }\n  groupAssignee {\n    ...AvatarNode_Node\n    id\n  }\n}\n\nfragment AvatarNode_Node on Node {\n  __isNode: __typename\n  __typename\n  ... on Group {\n    groupName: name\n  }\n  ... on Patient {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on Provider {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on User {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on ChatActivity {\n    patient {\n      name\n      oid_avatar\n      isOnline\n      id\n    }\n  }\n}\n\nfragment ButtonChatActivityOpen_ChatActivity on ChatActivity {\n  _id\n}\n\nfragment ButtonChatActivityReassign_ChatActivity on ChatActivity {\n  _id\n}\n\nfragment ButtonChatMessageSubmit_Patient on Patient {\n  doNotContact\n  contact {\n    active\n    type\n  }\n  ...PopperPatientContactSelect_Patient\n}\n\nfragment CardPatient_Patient on Patient {\n  ...AvatarNode_Node\n  _id\n  name\n  firstname\n  lastname\n  medicalRecordNumber\n  createdAt\n  lastLogin\n  dateOfBirth {\n    day\n    month\n    year\n  }\n}\n\nfragment ChatInput_Patient on Patient {\n  _id\n  createdAt\n  updatedAt\n  balance\n  name\n  firstname\n  lastname\n  doNotContact\n  contact {\n    active\n    type\n    value\n    archived\n  }\n  subscribers {\n    subscribed\n    user\n  }\n  ...ButtonChatMessageSubmit_Patient\n}\n\nfragment ChatMessageTyping_Node on Node {\n  __isNode: __typename\n  ... on Patient {\n    _id\n  }\n  ... on Provider {\n    _id\n  }\n  ... on User {\n    _id\n  }\n  ...AvatarNode_Node\n}\n\nfragment ChatMessage_Message on Message {\n  automated\n  createdAt\n  oid_file\n  ref\n  text\n  type\n  visibility\n  mentions {\n    mention\n  }\n  createdBy(includeDeleted: true) {\n    name\n    ...AvatarNode_Node\n    id\n  }\n  patient(includeDeleted: true) {\n    name\n    ...AvatarNode_Node\n    id\n  }\n  ...TypographyMessageDetails_Message\n}\n\nfragment ChatMessage_Viewer on User {\n  user {\n    salesforceData {\n      respectProvisioning\n    }\n    setting {\n      settings {\n        communication {\n          suppressMessagesByProvisioning\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment Chat_Patient on Patient {\n  ...InfiniteScrollMessages_Patient\n  ...ChatInput_Patient\n  chatActivity {\n    status\n    deleted\n    ...ActionsChatActivity_ChatActivity\n    id\n  }\n}\n\nfragment Chat_Viewer on User {\n  ...InfiniteScrollMessages_Viewer\n}\n\nfragment HubPatientJourney_Patient on Patient {\n  _id\n  name\n  firstname\n  lastname\n  master\n  dateOfBirth {\n    day\n    month\n    year\n  }\n}\n\nfragment IconButtonPatientActions_Patient_2hOuXI on Patient {\n  _id\n  chatActivity {\n    _id\n    status\n    assignee {\n      _id\n      id\n    }\n    groupAssignee {\n      _id\n      id\n    }\n    id\n  }\n}\n\nfragment IconButtonPatientActions_Viewer on User {\n  _id\n  roles\n}\n\nfragment IconPatientContactType_PatientContact on PatientContact {\n  type\n}\n\nfragment InfiniteScrollMessages_Patient on Patient {\n  id\n  _id\n  ...ChatMessageTyping_Node\n  name\n  firstname\n  lastname\n  master\n  avatar: oid_avatar\n  messagesConnection(first: 25, filter: {_operators: {visibility: {in: [public, internal]}, status: {ne: skipped}}}) {\n    edges {\n      node {\n        _id\n        oid_patient\n        text\n        type\n        channel\n        key\n        externalId {\n          value\n        }\n        externalStatus {\n          reason\n        }\n        retry {\n          originalMessage\n          count\n        }\n        oid_facility\n        oid_createdBy\n        oid_recipient\n        ...ChatMessage_Message\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment InfiniteScrollMessages_Viewer on User {\n  ...ChatMessage_Viewer\n}\n\nfragment ListItemPatientContact_PatientContact on PatientContact {\n  __typename\n  active\n  type\n  value\n  ...IconPatientContactType_PatientContact\n}\n\nfragment ListPatientContacts_Patient on Patient {\n  doNotContact\n  contact {\n    active\n    type\n    value\n    ...ListItemPatientContact_PatientContact\n  }\n}\n\nfragment PopperPatientContactSelect_Patient on Patient {\n  ...ListPatientContacts_Patient\n}\n\nfragment ToolbarNavigationPatient_Patient on Patient {\n  _id\n  ...AvatarNode_Node\n  ...TypographyNodeName_Node\n  ...TypographyNodeDob_Node\n}\n\nfragment TypographyMessageDetails_Message on Message {\n  channel\n  createdAt\n  ref\n  secure\n  type\n  visibility\n  to\n  facility {\n    _id\n    name\n    id\n  }\n  media {\n    url\n  }\n  retry {\n    count\n  }\n  notifyTo {\n    channel\n    to\n  }\n  status\n  externalStatus {\n    reason\n  }\n}\n\nfragment TypographyNodeDob_Node on Node {\n  __isNode: __typename\n  ... on Patient {\n    dateOfBirth {\n      day\n      month\n      year\n    }\n  }\n  ... on Provider {\n    dateOfBirth {\n      day\n      month\n      year\n    }\n  }\n  ... on User {\n    dateOfBirth {\n      day\n      month\n      year\n    }\n  }\n}\n\nfragment TypographyNodeName_Node on Node {\n  __isNode: __typename\n  ... on Group {\n    groupName: name\n  }\n  ... on Patient {\n    name\n  }\n  ... on Provider {\n    name\n  }\n  ... on User {\n    name\n  }\n  ... on Facility {\n    facilityName: name\n  }\n}\n"
  }
};
})();
(node as any).hash = '5de1a708b2b0f0aeb810eaa8d48da49b';
export default node;
